
import { Farm } from "@/types/database.types";
import * as XLSX from 'xlsx';

/**
 * Generate Excel template for farm uploads
 * @returns ArrayBuffer of Excel file
 */
export function generateFarmExcelTemplate(): ArrayBuffer {
  const headers = [
    { header: 'Region*', key: 'region', width: 20 },
    { header: 'Farm Size*', key: 'farm_size', width: 15 },
    { header: 'Irrigation Type', key: 'irrigation_type', width: 20 },
    { header: 'Latitude', key: 'latitude', width: 15 },
    { header: 'Longitude', key: 'longitude', width: 15 },
    { header: 'Farmer Name*', key: 'farmer_name', width: 25 },
    { header: 'Phone Number*', key: 'phone_number', width: 20 },
    { header: 'Union Name', key: 'union_name', width: 25 },
    { header: 'Has Contract', key: 'has_contract', width: 15 },
    { header: 'Has Phone Access', key: 'has_phone_access', width: 15 },
    { header: 'Officer', key: 'officer', width: 20 },
    { header: 'Product Name*', key: 'product_name', width: 20 },
    { header: 'Distance from Addis', key: 'distance_from_addis', width: 20 },
    { header: 'City', key: 'city', width: 20 },
    { header: 'Area', key: 'area', width: 20 },
    { header: 'Harvest Start Date', key: 'harvest_start_date', width: 20 },
    { header: 'Harvest End Date', key: 'harvest_end_date', width: 20 },
    { header: 'Kebelle', key: 'kebelle', width: 15 },
    { header: 'Estimated Harvest (kg)', key: 'estimated_harvest_kg', width: 20 },
    { header: 'Starting Date', key: 'starting_date', width: 20 },
    { header: 'Ending Date', key: 'ending_date', width: 20 },
  ];

  // Sample data row with more detailed examples
  const sampleData = [
    {
      region: 'Example: Oromia',
      farm_size: 2.5,
      irrigation_type: 'Example: Drip',
      latitude: 9.0222,
      longitude: 38.7468,
      farmer_name: 'Example: John Doe',
      phone_number: 'Example: +251912345678',
      union_name: 'Example: Oromia Coffee Union',
      has_contract: 'Yes',  // Simple Yes/No values
      has_phone_access: 'Yes',
      officer: 'Example: Officer Name',
      product_name: 'Example: Coffee',
      distance_from_addis: 100,
      city: 'Example: Addis Ababa',
      area: 'Example: Bole',
      harvest_start_date: '2025-01-15',
      harvest_end_date: '2025-02-28',
      kebelle: 'Example: Local Area',
      estimated_harvest_kg: 500,  // Numeric value in kg
      starting_date: '2025-01-15',
      ending_date: '2025-02-28',
    }
  ];

  // Create workbook and worksheet
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(sampleData, { 
    header: headers.map(h => h.key)
  });

  // Set column widths
  worksheet['!cols'] = headers.map(h => ({ width: h.width }));

  // Add headers
  XLSX.utils.sheet_add_aoa(worksheet, [headers.map(h => h.header)], { origin: 'A1' });

  // Add a note about required fields
  const noteCell = XLSX.utils.encode_cell({ r: sampleData.length + 2, c: 0 });
  worksheet[noteCell] = { v: "* Required fields. " +
    "Date format should be YYYY-MM-DD. " +
    "Yes/No fields should contain 'Yes' or 'No'. " +
    "Numbers should not contain any currency symbols or commas. " +
    "Estimated Harvest (kg) is used to set the expected quantity for harvests." };

  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Farm Template');

  // Convert to ArrayBuffer
  return XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });
}
